import React, { useState, useEffect } from "react";
import { Table, Button } from "antd";
import axios from "axios";
import Swal from "sweetalert2";
import { Spinner } from "react-bootstrap";
import whatsapp from "../../../src/assets/img/WhatsApp_icon.png";
import { Link, useNavigate } from "react-router-dom";
import { decryptData, encryptData } from "../../decryptHelper";

export default function Resulthistory() {
  const user_id = localStorage.getItem("userid");
  const [isLoading, setIsLoading] = useState(true);
  const devid = localStorage.getItem("dev_id");

  const [data, setData] = useState([]);
  const [totalComm, settotalComm] = useState([]);
  const [totalPlayed, settotalPlayed] = useState([]);
  const [Refcomm, setRefcomm] = useState([]);
  const [RefBonus, setRefBonus] = useState([]);
  const [RedeemtotalAmount, setRedeemtotalAmount] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [showButton, setShowButton] = useState(false);
  const [ref_message, setref_message] = useState(null);
  const [apiResponse, setApiResponse] = useState(null);

  const [redeemAmount, setRedeemAmount] = useState("");
  const [TotalBonus, setTotalBonus] = useState("");
  const [BonusMin, setBonusMin] = useState("");
  const [BonusMax, setBonusMax] = useState("");
  const [error, setError] = useState("");
  const [loadingbutton, setLoadingbutton] = useState(false);
  const [refData, setRefData] = useState({ ref_code: "", ref_by: "" });
  const [loadingButton, setLoadingButton] = useState(false);
  const [loadButton, setLoadButton] = useState(false);
  const [itemsToShow, setItemsToShow] = useState(20);
  const getProfile = async () => {
    setLoadButton(false);
    const apiUrl = `${process.env.REACT_APP_API_URL_NODE}user-profile`;
    const requestData = {
      app_id: process.env.REACT_APP_API_ID,
      user_id,
      device_id: devid,
    };
    const encryptedText = encryptData(requestData);
    const datasend = { data: encryptedText };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(datasend),
      });

      const response1 = await response.json();
      const data23 = decryptData(response1.encryptedResponse);
      const data = data23;
      setLoadButton(true);

      if (data.is_login === "0") window.location.href = "/";
      console.warn("rrrrrrrrrrrrrrrr", data);
      if (data.success === "1") {
        setApiResponse(data.data.is_bonus);
        setref_message(data.data.ref_message);
        setRefData({ ref_code: data.data.ref_code, ref_by: data.data.ref_by });
        setShowButton(!data.data.ref_by); // Show button only if ref_by is empty
      } else {
        console.error("API Error:", data.message);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };
  // const pageSize = 5;
  const handleSearch = (value) => {
    const filtered = data.filter((item) =>
      Object.values(item).some(
        (field) =>
          typeof field === "string" &&
          field.toLowerCase().includes(value.toLowerCase()),
      ),
    );
    setSearchText(value);
    setFilteredData(filtered);
    setCurrentPage(1);
  };

  const bonuslist = async () => {
    const user_id = localStorage.getItem("userid");
    const requestData = {
      user_id: user_id,
    };
    const encryptedText = encryptData(requestData);
    const datasend = { data: encryptedText };
    const config = {
      method: "POST",
      url: `${process.env.REACT_APP_API_URL_NODE}bonus-report-list`,
      headers: {
        "Content-Type": "application/json",
      },
      data: datasend,
    };
    try {
      const response1 = await axios(config);
      const response = decryptData(response1.data.encryptedResponse);
      if (response.data.success == "1") {
        setData(response.data.data);
        settotalComm(response.data.total_comm);
        settotalPlayed(response.data.total_played);
        setRefcomm(response.data.commissionRate);
        setRefBonus(response.data.total_comm);
        setRedeemtotalAmount(response.data.RedeemtotalAmount);
        setTotalBonus(response.data.total_bonus);
        setBonusMin(response.data.bounsmin);
        setBonusMax(response.data.bounsmax);
      } else {
        console.log("no record found");
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    bonuslist();
    getProfile();
  }, []);

  // const formatDateString = (dateString) => {
  //   const date = new Date(dateString);
  //   return date.toLocaleDateString();
  // };
  const navigate = useNavigate();

  const columns = [
    {
      title: "Date",
      dataIndex: "_id",
      key: "date",
    },

    {
      title: "Total Played",
      dataIndex: "totalAmount",
      key: "total",
    },
    {
      title: "Comm",
      dataIndex: "winAmount",
      key: "winAmount",
      render: (text) => parseFloat(text).toFixed(2),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button
          type="link"
          onClick={() => navigate(`/bonus-report-details/${record._id}`)}
        >
          View
        </Button>
      ),
    },
  ];

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    });
    return () => clearTimeout(timer);
  }, []);

  const redeemBonus = async (event) => {
    event.preventDefault();
    if (!redeemAmount || redeemAmount < BonusMin || redeemAmount > BonusMax) {
      setError(
        "Please enter a valid amount between " + BonusMin + " and " + BonusMax,
      );
      return;
    }
    setError("");
    setLoadingbutton(true);
    const requestData = {
      user_id: user_id,
      amount: redeemAmount,
    };
    const encryptedText = encryptData(requestData);
    const datasend = { data: encryptedText };
    const config = {
      method: "POST",
      url: `${process.env.REACT_APP_API_URL_NODE}bonus-report-redem`,
      headers: {
        "Content-Type": "application/json",
      },
      data: datasend,
    };
    try {
      const response1 = await axios(config);
      const response = decryptData(response1.data.encryptedResponse);
      if (response.data.success == "1") {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Your bonus has been redeemed successfully!",
        });
        bonuslist();
        setLoadingbutton(false);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data.message,
        });
      }
    } catch (error) {
      console.error("Error redeeming bonus:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while redeeming your bonus. Please try again later.",
      });
    }
  };

  const loadMore = () => {
    setItemsToShow(itemsToShow + 20);
  };
  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(
        "https://ranabhaimatka.com/create-account?reffercode=" +
        refData.ref_code,
      )
      .then(() => {
        Swal.fire(
          "Copied!",
          "Your refer Link has been copied to the clipboard.",
          "success",
        );
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
        Swal.fire("Error", "Failed to copy the refer code.", "error");
      });
  };
  const copyToClipboard1 = () => {
    navigator.clipboard
      .writeText(refData.ref_code)
      .then(() => {
        Swal.fire(
          "Copied!",
          "Your refer Code has been copied to the clipboard.",
          "success",
        );
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
        Swal.fire("Error", "Failed to copy the refer code.", "error");
      });
  };

  return (
    <div>
      {isLoading && (
        <div className="spinner-wrapper">
          <div className="loadernew2"></div>
        </div>
      )}
      {!isLoading && (
        <section id="Help" className="margin-bottom-88">
          <div className="margin-bottom-49 mb-0">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
               <h2
  className="referalcode"
  style={{
    color: "#FFD700",
    fontWeight: "600",
    lineHeight: "1.5",
    textAlign: "center",
  }}
>
  अगर आप अपने रेफरल कोड से किसी को जोड़ते हैं, तो आपको उसकी
  खेली हुई गेम का 5% कमीशन तुरंत मिलेगा।{" "}
</h2>
                </div>
                {/* <div className="col-md-12">
                  <div className="chatsupportdesign">
                    <div className="d-flex justify-content-between align-items-center referlink_design">
                      <h4>Reffer Link </h4>
                       <h6
    style={{
      color: "white",
      fontSize: "14px",
      fontWeight: "400",
      margin: 0,
      lineHeight: "1.3",
      textAlign: "center",
      flex: 1,
    }}
  >
    अब अपने दोस्तों को भी एप्लीकेशन share करके अच्छा पैसा कमा सकते हैं।
    शेयर करने के लिऐ व्हाट्स ऐप पे क्लिक करे।
  </h6>
                      <div className="whatsappicon">
                        <Link
                          className="w-100"
                          to={`whatsapp://send?text=गली दिसावर गेम खेलने वाले 
                  DOWNLOAD करे.....ranabhaimatka.com ऐप क्योंकि इसमें मिलता है आपको सबसे जायदा रेट 10के 950 रुपए और सबसे FAST एंड SAFE PAYMENT
                   https://ranabhaimatka.com/create-account?reffercode=${refData.ref_code}`}
                        >
                          <img src={whatsapp} alt="whatsapp" />
                        </Link>
                      </div>
                    </div>
                    <div className="referlinkdesign">
                      <p>
                        Referral Link:
                        https://ranabhaimatka.com/create-account?reffercode=
                        {refData.ref_code}
                      </p>
                      {refData.ref_code && <p>{refData.ref_code}</p>}
                      <div className="d-flex justify-content-center gap-2">
                        <button
                          className="buttoncopylink"
                          onClick={copyToClipboard}
                        >
                          Copy Link
                        </button>
                        <button
                          className="buttoncopylink"
                          onClick={copyToClipboard1}
                        >
                          Copy Reffer Code
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="bonusreport">
                    <h3>Refer And Earn</h3>
                  </div>
                </div> */}
                
<div className="col-md-12">
  <div className="chatsupportdesign">

    <div className="d-flex justify-content-between align-items-center referlink_design">

      {/* <h4>Referral Link</h4> */}

      {/* <h6
        style={{
          color: "white",
          fontSize: "14px",
          fontWeight: "400",
          margin: 0,
          lineHeight: "1.3",
          textAlign: "center",
          flex: 1,
        }}
      >
        अब अपने दोस्तों को भी एप्लीकेशन शेयर करके अच्छा पैसा कमा सकते हैं।
        शेयर करने के लिए व्हाट्सऐप पर क्लिक करें।
      </h6> */}

      <h6
  style={{
    color: "rgb(255, 215, 0)",
    fontSize: "14px",
    fontWeight: "500",
    margin: 0,
    lineHeight: "1.3",
    textAlign: "center",
    flex: 1,
  }}
>
 <div> </div> अब अपने दोस्तों को भी एप्लीकेशन शेयर करके अच्छा पैसा कमा सकते हैं।
  शेयर करने के लिए व्हाट्सऐप पर क्लिक करें।
</h6>

      <div className="whatsappicon">
        <a
          className="w-100"
          href={`https://wa.me/?text=${encodeURIComponent(
            `गली दिसावर गेम खेलने वाले DOWNLOAD करे..... ranabhaimatka.com ऐप क्योंकि इसमें मिलता है आपको सबसे ज्यादा रेट 10 के 950 रुपए और सबसे FAST एंड SAFE PAYMENT

https://ranabhaimatka.com/create-account?reffercode=${refData.ref_code}`
          )}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={whatsapp} alt="WhatsApp" />
        </a>
      </div>

    </div>

    <div className="referlinkdesign">

      <p>
        Referral Link:
        <br />
        https://ranabhaimatka.com/create-account?reffercode=
        {refData.ref_code}
      </p>

      {refData.ref_code && (
        <p>{refData.ref_code}</p>
      )}

      <div className="d-flex justify-content-center gap-2">

        <button
          type="button"
          className="buttoncopylink"
          onClick={copyToClipboard}
        >
          Copy Link
        </button>

        <button
          type="button"
          className="buttoncopylink"
          onClick={copyToClipboard1}
        >
          Copy Referral Code
        </button>

      </div>

    </div>

  </div>

 <div 
  className="bonusreport" 
  style={{ 
    display: "flex", 
    justifyContent: "space-between", 
    alignItems: "center", 
    padding: "10px", // Thodi padding taaki text chipke nahi
    backgroundColor: "#0f3e3e", // Aapka background color (optional)
    color: "white" // Text color white taaki background par dikhe
  }}
>
  {/* Left side empty spacer taaki heading center mein rahe */}
  {/* <div style={{ width: "100px" }}></div> */}

  {/* Center Heading */}
  <h3 style={{ margin: 0, textAlign: "center" }}>Refer And Earn</h3>

  {/* Right Side Link (Last mein show hoga) */}

<Link
  to="/View-Child"
  style={{
    textDecoration: "none",
    color: "#fff",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    minWidth: "115px",
    padding: "8px 14px",
    borderRadius: "8px",
    background: "linear-gradient(135deg, rgb(56, 199, 179), rgb(56, 199, 179))",
    boxShadow: "0 4px 12px rgba(102, 126, 234, 0.35)",
    transition: "all 0.3s ease",
    fontWeight: "600",
    fontSize: "14px",
    cursor: "pointer",
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = "translateY(-2px)";
    e.currentTarget.style.boxShadow =
      "0 6px 16px rgba(102, 126, 234, 0.5)";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow =
      "0 4px 12px rgba(102, 126, 234, 0.35)";
  }}
>
    Referral   User
  <span style={{ fontSize: "16px" }}>→</span>
</Link>


</div>
</div>


                <div className="col-12">
                  <h5 className="text-dark text-center">Bonus Report</h5>
                  <table className="table bonusreportth">
                    <thead className="bonusreportth">
                      <th>Total Played</th>
                      <th>Total Bonus</th>
                      <th>Remaining Bonus</th>
                      <th>Total Redeem Amount</th>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{totalPlayed}</td>
                        <td>{TotalBonus}</td>
                        <td>{RefBonus}</td>
                        <td>{RedeemtotalAmount}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="col-md-12">
                  <h6 className="text-dark redeem">
                    Enter Redeem Amount
                    <span className="d-block text-danger minmaxamt">
                      (Min - {BonusMin} and Max- {BonusMax} can withdraw)
                    </span>
                  </h6>
                  <div className="row align-items-center">
                    <div className="col-8 col-sm-9">
                      <input
                        type="number"
                        required=""
                        onChange={(e) => setRedeemAmount(e.target.value)}
                        placeholder="Enter Amount"
                        name="amount"
                        className="form-control bonusreportinput"
                      />
                    </div>
                    <div className="col-4 col-sm-3">
                      <button
                        type="button"
                        onClick={redeemBonus}
                        className="playgames bonsureport w-100"
                        disabled={loadingbutton}
                      >
                        Submit {loadingbutton && <Spinner animation="border" />}
                      </button>
                    </div>
                    {error && <p className="text-danger">{error}</p>}
                  </div>
                </div>
                <div className="col-md-12 mt-3">
                  <Table
                    dataSource={
                      searchText
                        ? filteredData.slice(0, itemsToShow)
                        : data.slice(0, itemsToShow)
                    }
                    columns={columns}
                    pagination={false}
                  />
                  {data.length > itemsToShow && (
                    <div style={{ textAlign: "center", marginTop: "20px" }}>
                      <Button onClick={loadMore}>Load More</Button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </div>
  );
}
